module.exports = __webpack_public_path__ + "static/virus-prototype-b662540e735eb06595e4d5a0a5bdfc04.mp4";